export default __webpack_public_path__ + "static/media/attachment-icon.bad72950.svg";